import ConditionalRender from "../../../ConditionalRender"
import { Badge } from "../../../design_system/components/Input Fields/Badge.jsx"

export const SuggestionTags = ({ tags, ...props }) => {
    return (
        <ConditionalRender if={tags}>
            <div className="suggestion-tags__wrapper flex">
                <div className='body-s suggestion-tags__label'>Tags:</div>
                <div className="suggestion-tags__list flex flex-wrap">
                    {tags?.filter(tag => !tag.includes("_not_")).map(tag => (
                        <Badge key={tag} type="Success" label={tag} fontClass="support-m-semibold" />))}
                    {tags?.filter(tag => tag.includes("_not_")).map(tag => (
                        <Badge key={tag} type="Error" label={tag} fontClass="support-m-semibold" />))}
                </div>
            </div>
        </ConditionalRender>
    )
}
